"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dompurify = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const dompurify = exports.dompurify = (0, _dompurify.default)(window);
dompurify.setConfig({
  ADD_ATTR: ['target']
});
dompurify.addHook('afterSanitizeAttributes', node => {
  if (!node.getAttribute('target')) {
    return;
  }
  node.setAttribute('rel', 'noopener noreferrer');
});